import React from 'react'
import GlassSelect from './GlassSelect'
import VentilationSelect from './VentilationSelect'

class FormRow extends React.Component {

    constructor(props) {
        super(props)
        this.textInput = React.createRef();
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    componentDidMount() {
        this.focusTextInput()
    }

    calculatem2() {

        const { height, width, number } = this.props

        return Math.round(height*width*number/10000) / 100;
    }

    focusTextInput() {
        this.textInput.current.focus();
    }

    render() {

        const { height, width, number, position, type, glass, ventilation, commentsGlass, commentsVentilation, commentsWindow, nr  } = this.props

        return (
            <div className="form-row align-items-center mb-5 mb-md-0">
                    <div className="col-12 d-md-none border-bottom mb-3">
                        <strong>Ruit #{ nr + 1}</strong>
                    </div>

                    <div className="d-none d-md-block col-md-2 mb-4 mb-md-2">
                        <div className="form-row align-items-center">
                            <div className="col-sm-2 text-muted">
                                { nr + 1}
                            </div>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" name="position" value={position} onChange={(event) => this.props.onChange("position", event.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3 mb-4 mb-md-2">

                        <div className="form-row">
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                                <label className="d-md-none">Breedte</label>
                                <input type="number" ref={this.textInput} className="form-control" name="width" value={width} onChange={(event) => this.props.onChange("width", event.target.value)} />
                            </div>
                            <div className="col-12 col-md-6">
                                <label className="d-md-none">Hoogte</label>
                                <input type="number" className="form-control" name="height" value={height} onChange={(event) => this.props.onChange("height", event.target.value)} />
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-md-1 mb-4 mb-md-2">
                        <label className="d-md-none">Aantal</label>
                        <input type="number" className="form-control" name="number" value={number} onChange={(event) => this.props.onChange("number", event.target.value)} />
                    </div>
                    <div className="col-12 col-md-1 mb-4 mb-md-2">

                        <div className="form-check">
                            <input className="form-check-input" name={`type_${nr}`} type="radio" value="1" onChange={(event) => this.props.onChange("type", event.target.value)} checked={type === '1'}/>
                                <label className="form-check-label">
                                    Glas
                                </label>
                        </div>

                        <div className="form-check">
                            <input className="form-check-input" name={`type_${nr}`} type="radio"  value="2" onChange={(event) => this.props.onChange("type", event.target.value)} checked={type === "2"} />
                            <label className="form-check-label">
                                Draairaam
                            </label>
                        </div>

                    </div>
                    <div className="col-12 col-md-2 mb-4 mb-md-2">
                        <label className="d-md-none">Glastype</label>
                        <GlassSelect className="form-control" name="glass" value={glass} onChange={(event) => this.props.onChange("glass", event.target.value)}/>
                    </div>
                    <div className="col-12 col-md-2 mb-4 mb-md-2">
                        <label className="d-md-none">Rooster</label>
                        <VentilationSelect className="form-control" name="ventilation" value={ventilation} onChange={(event) => this.props.onChange("ventilation", event.target.value)}/>
                    </div>
                    <div className="col-12 col-md-1 mb-4 mb-md-2">
                        <div className="form-row align-items-center">
                            <div className="col text-center d-md-none d-xl-block">
                                { width && width && number &&
                                <span>{this.calculatem2()} <span className="d-md-none">m<sup>2</sup></span></span>
                                }
                            </div>

                            <div className="col text-right">
                                <button type="button" className="btn btn-default" data-toggle="modal" data-target={`#modal_${this.props.i}`}>
                                    <i className="far fa-comment"/>
                                </button>

                                <div className="modal fade" id={`modal_${this.props.i}`} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="exampleModalLabel">Opmerkingen toevoegen</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <textarea rows="4" className="form-control mb-4 mb-md-2" placeholder="Opmerkingen glas" name="commentsGlass" value={commentsGlass} onChange={(event) => this.props.onChange("commentsGlass", event.target.value)}></textarea>
                                                <textarea rows="4" className="form-control mb-4 mb-md-2" placeholder="Opmerkingen roosters" name="commentsVentilation" value={commentsVentilation} onChange={(event) => this.props.onChange("commentVentilation", event.target.value)}></textarea>
                                                <textarea rows="4" className="form-control mb-4 mb-md-2" placeholder="Opmerkingen raam" name="commentsWindow" value={commentsWindow} onChange={(event) => this.props.onChange("commentsWindow", event.target.value)}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        )
    }
}

export default FormRow


// WEBPACK FOOTER //
// ./src/components/FormRow.js